import React from 'react';
import { Link } from "react-router-dom";

import {Poll, Chat, ReactionTriggers, Questions} from 'Components/MainStage';
import Auth from 'Components/Layouts/Auth';


import {translation} from 'Services/TranslationHelpers';

import Base from './Base';
import { asset } from "Services/BaseHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCross, faTimes } from "@fortawesome/free-solid-svg-icons";
import { PrimaryButton } from "Components/Button";
import Profile from "Pages/Settings/Profile";
import AgendaIndex from "Pages/Agenda";
import CelebrationWallTab from "Pages/Cms/Elements/CelebrationWallTab";
import CelebrationWall from "Pages/Cms/Elements/CelebrationWall";

import { Networking } from "Components/Networking";

export default class Remote extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = true;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
        currentPoll: null,
        showMenu: true,
        tab: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method handleSetTab
     * @param {string} tab
     */
    handleSetTab = (tab) => {
        this.setState({
            tab,
            showMenu: false
        });
    };
    /**
     * @method render
     * @return {*}
     */
    renderHeader() {
        return (
            <React.Fragment>
                <nav className="w-full bg-white py-5 flex justify-between">
                        <Link className="w-36 block mx-auto" to="/main-stage/remote">
                            <img src={asset('/images/logo.png')} alt="Speedo" className="w-36 mx-auto ml-4" />
                        </Link>
                        <div
                            onClick={() => this.setState({showMenu: true})}
                            className="flex-col text-center p-4 flex justify-center cursor-pointer"
                        >
                            <FontAwesomeIcon icon={faBars} size="lg" className={"text-app-red pl-5"} />
                        </div>
                </nav>
            </React.Fragment>
        );
    }
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {currentSession, tab, showMenu} = this.state;

        return (
            <>
             {this.renderHeader()}

                {currentSession && (
                    <React.Fragment>
                        {/*<div className={"w-full flex justify-center"}>*/}
                        {/*    <PrimaryButton*/}
                        {/*        onClick={() => this.setState({showMenu: true})}*/}
                        {/*        text="Return to main menu"*/}
                        {/*        className={"mx-auto"}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {!showMenu && (
                            <div className="h-5/6 mt-8">
                                {tab === null && this.renderNoTab()}
                                {tab === 'agenda' && this.renderAgenda()}
                                {tab === 'networking' && this.renderChat()}
                                {tab === 'profile' && this.renderProfile()}
                                {tab === 'floorplan' && this.renderFloorPlan()}
                                {tab === 'questions' && this.renderQuestions()}
                                {tab === 'celebration-wall' && this.renderCelebrationWall()}
                            </div>
                        )}


                        {showMenu && (
                            <div className="absolute min-h-screen w-screen bg-white top-0 left-0 flex justify-center z-20">
                                  <FontAwesomeIcon
                                      icon={faTimes}
                                      size="2x"
                                      onClick={() => this.setState({showMenu: false})}
                                      className="absolute  right-10 top-10 cursor-pointer  mr-2 text-app-red"
                                  />

                                <div className={"max-w-2xl mx-auto content-center"}>
                                    <div className="flex justify-center py-8">
                                        <img className="w-20" src={asset('images/logo.png')} />
                                    </div>

                                    <p className={"text-app-purple text-xl font-light font-gilroy p-8"}>
                                        Welcome to the Speedo S2 24 Remote Platform.
                                        Here you can explore your bespoke event agenda,
                                        view the event floorplan, upload photos
                                        and ask us any questions you may have.
                                    </p>

                                    <div className="gap-1 grid grid-cols-2 w-full px-8 pb-8">
                                        {this.renderButton(translation('main_stage_frontend', 'agenda_tab_text'), 'agenda')}
                                        {this.renderButton(translation('main_stage_frontend', 'floor_plan_tab_text'), 'floorplan')}
                                        {this.renderButton(translation('main_stage_frontend', 'chat_tab_text'), 'networking')}
                                        {this.renderButton(translation('main_stage_frontend', 'profile_tab_text'), 'profile')}
                                        {this.renderButton(translation('main_stage_frontend', 'celebration_wall_tab_text'), 'celebration-wall')}
                                        {this.renderButton(translation('main_stage_frontend', 'questions_tab_text'), 'questions')}
                                    </div>
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}

                {!currentSession && (
                    <div className="h-full w-full flex justify-center items-center">
                        <p>{translation('main_stage_frontend', 'no_sessions_running')}</p>
                    </div>
                )}
            </>
        );
    }

    /**
     * @method renderNoTab
     * @returns {JSX.Element}
     */
    renderNoTab = () => {
        return (
            <div className="h-full w-full flex flex-col justify-center items-center p-5">
                <p className={"text-app-purple text-xl font-light font-gilroy"}>
                    Welcome to the Speedo S2 24 Remote Platform.
                    Here you can explore your bespoke event agenda,
                    view the event floorplan, upload photos
                    and ask us any questions you may have.
                </p>

                <p className={"text-app-purple text-xl font-light font-gilroy"}>
                    Select the menu Icon to begin
                </p>
            </div>
        );
    };

    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderChat = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex flex-col justify-center items-center p-5">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">Networking</span>
                <div className="h-full w-full flex-1 flex flex-col text-black">
                    <Networking
                        displayUsers={true}
                        displayChats={true}
                        displayChat={true}
                        useGroups={false}
                        selectedMessageToType='App\Models\User'
                        selectedMessageToId={this.props.match?.params?.user}
                        sessionId={currentSession?.id}
                    />
                </div>
            </div>
        );
    };
    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderFloorPlan = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex flex-col justify-center items-center p-5">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">Floorplan</span>
                <img src={asset('images/remote/floor-1.jpg')} />
                <img src={asset('images/remote/floor-2.jpg')} />
            </div>
        );
    };
    /**
     * @method renderChats
     * @return {JSX.Element}
     */
    renderAgenda = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex flex-col justify-center items-center p-2">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">Agenda</span>
                <AgendaIndex
                    sessionId={currentSession?.id}
                    remoteControlSession={true}
                />
            </div>
        );
    };
    /**
     * @method renderReactions
     * @return {JSX.Element}
     */
    renderReactions = () => {
        const {currentSession} = this.state;

        return (
            <div className={"max-w-2xl flex p-10 justify-center gap-10 flex-wrap mx-auto content-center"}>
                <ReactionTriggers
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };

    /**
     * @method renderPolls
     * @return {JSX.Element}
     */
    renderPolls = () => {
        const {currentPoll, currentSession} = this.state;

        if (!currentPoll) {
            return (
                <div className="h-full w-full flex justify-center items-center">
                    {translation('main_stage_frontend', 'no_polls')}
                </div>
            );
        }

        return (
            <div className="h-full w-full flex justify-center items-center">
                <Poll
                    poll={currentPoll}
                    sessionId={currentSession.id}
                />
            </div>
        );
    };

    /**
     * @method renderQuestions
     * @return {JSX.Element}
     */
    renderQuestions = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex flex-col justify-between items-center p-5">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">Ask a question</span>
                <Questions
                    sessionId={currentSession?.id}
                />
            </div>
        );
    };
    /**
     * @method renderQuestions
     * @return {JSX.Element}
     */
    renderProfile = () => {
        const {currentSession} = this.state;

        return (
            <div className="h-full w-full flex flex-col justify-between items-center p-5 bg-app-gray">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">My Profile</span>
                <Profile
                    sessionId={currentSession?.id}
                    remoteControlSession={true}
                />
            </div>
        );
    };
    /**
     * @method renderCelebrationWall
     * @return {JSX.Element}
     */
    renderCelebrationWall = () => {
        return (
            <div className="h-full w-full flex flex-col justify-center items-center p-6">
                <span className="m-auto text-app-purple text-5xl font-semibold font-gilroy">Gallery</span>
                <CelebrationWall
                    remoteControlSession={true}
                />
            </div>
        );
    }

    /**
     * @method renderButton
     * @param {string} text
     * @param {string} tab
     * @return {JSX.Element}
     */
    renderButton = (text, tab) => {
        const {tab: activeTab} = this.state;

        return (
            <div  className={`
                     px-1 rounded-xl  justify-center relative
                    ${activeTab === tab ? 'bg-white text-white' : 'bg-app-green text-white'}
                `}
                  onClick={() => this.handleSetTab(tab)}
            >
                <button
                    className={`
                    w-full  text-white
                    ${activeTab === tab ? 'bg-app-red text-white' : 'bg-app-green text-white'}
                `}>
                    <img src={asset("images/remote/" + tab + ".jpg" )} className={"w-full my-auto mx-auto p-1"} />

                    <div className={"absolute top-12 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-app-green-banner text-md sm:text-3xl font-gilroy"}>{text}</div>
                </button>
            </div>
        );
    };

}
